import { DownloadReport } from '../actions/reports.actions';
import { ReportsState } from '../reducers/reports.reducer';
import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import {
  AggregatedHoldingsReportModel,
  IDownloadReportRequestObject,
} from 'src/app/models/reports';
import { Observable } from 'rxjs';
import { ReportsService } from 'src/app/services/http/reports.service';
import { getReportSuccessfulSelector } from 'src/app/store/reports/selectors/reports.selectors';

@Injectable()
export class ReportsFacade {

  reportSuccessful$ = this.store.select(getReportSuccessfulSelector);

  constructor(
    private store: Store<ReportsState>,
    private reportsService: ReportsService,
  ) {}

  downloadReport(downloadReportRequestObject: IDownloadReportRequestObject) {
    this.store.dispatch(new DownloadReport(downloadReportRequestObject));
  }

  getAggregatedHoldingsReport(
    reportQuery: any,
  ): Observable<AggregatedHoldingsReportModel[]> {
    return this.reportsService.getAggregatedHoldingsReport(reportQuery);
  }
}
